import React, { useState } from 'react';

import { observer } from 'mobx-react';

import { ButtonsRow } from '../../../components/ButtonsRow/ButtonsRow';
import { CoachSeatsWidget, paymentBundleService } from '../../../../../../payment';
import { setupEntityStore } from '../../../../../stores/setupEntityStore';

const ScanIqPaymentStep = observer(() => {
  const [isCoachSeatsCreated, setIsCoachSeatsCreated] = useState(false);

  const { entityId, stepperMethods } = setupEntityStore;
  const { goToNextStep } = stepperMethods;

  if (!entityId) {
    throw new Error('Entity id is not defined');
  }

  const handleNext = async () => {
    await paymentBundleService.setupDefaultScanIqPaymentBundle(entityId);
    goToNextStep();
  };

  const isNextBtnDisabled = !isCoachSeatsCreated;

  return (
    <div>
      <CoachSeatsWidget
        entityId={entityId}
        mode="CREATE"
        onSuccessSubmit={() => {
          setIsCoachSeatsCreated(true);
        }}
      />
      <ButtonsRow onNext={handleNext} yesDisabled={isNextBtnDisabled} />
    </div>
  );
});

export { ScanIqPaymentStep };
